// Core
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
// Styles
import './assets/global.scss'
// Layouts
// 3rd Party Components

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
